<template>
    <div class="Warp">
    <van-notice-bar color="#1989fa" background="#ecf9ff">
      卡券使用详情
    </van-notice-bar>
    <van-cell-group>
        <van-cell title="消费者名称" :value="detail.name||'暂无信息'" />
        <van-cell title="消费者电话" :value="detail.tel||'暂无信息'" />
        <van-cell title="卡券编号" :value="detail.card_num||'暂无信息'" />
        <van-cell title="卡券名称" :value="detail.title||'暂无信息'" />
        <!-- <van-cell title="卡券类型" :value="detail.card_type=='FULL_REDUCE'?'满减':'折扣'" />
        <van-cell title="卡券介绍" :label="detail.description" /> -->
        <van-cell title="消费者满多少" :value="detail.consumer_full_money||'暂无信息'" />
        <van-cell title="消费者减多少" :value="detail.consumer_reduce_money||'暂无信息'" />
        <van-cell title="商户名称" :value="detail.trans_subject||'暂无信息'" />
        <van-cell title="订单号" :value="detail.out_trade_no||'暂无信息'" />
        <van-cell title="订单金额" :value="detail.order_fee||'暂无信息'" />
        <van-cell title="实际支付金额" :value="detail.total_fee||'暂无信息'" />
        <van-cell title="优惠金额" :value="detail.discount_fee||'暂无信息'" />
        <van-cell title="应结订单金额" :value="detail.settle_fee||'暂无信息'" />
    </van-cell-group>
    </div>
</template>
<script>
export default {
    data(){
        return {
            detail:{}
        }
    },
    mounted(){
        this.getDetail();
    },
    methods:{
        getDetail(){
            this.detail = this.$route.query
            console.log(this.detail);
        },
    }
}
</script>
<style lang="less" scoped>
    .store{
        // text-align: right;
        margin-bottom:10px;
    }
    /deep/ .van-cell__title{
        flex:1
    } 
    /deep/ .van-cell__value{
        flex:2
    } 
</style>